
import {Component, Prop, Vue} from "vue-property-decorator";
import {IReport} from "@/modules/Report/interfaces/report.interface";
import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class AgentTableTotal extends Vue {
    @Prop() dataProps: IReport.ITableProp[];

    get total(): IMovementsReport.ITableTotal {
      let resultData = {...this.$store.state.report.tableTotal};
      this.dataProps.forEach(cell => {
        switch (cell.propType) {
          case IApp.SortingPropType.Number:
            resultData[`${cell.prop}Printed`] = resultData[cell.prop] ? this.$options.filters.currency(resultData[cell.prop], cell.isMoney ? '₽' : '') : '';
            break;

          default:
            break;
        }
      });

      let avgSum = Math.ceil(resultData.sumPays / resultData.cntPays);
      resultData.avgSum = avgSum;

      let moneyProps = ['sumPays', 'avgSum'];
      moneyProps.forEach(prop => {
        resultData[prop] = resultData[prop] ? this.$options.filters.currency(resultData[prop],  '₽') : '';
      });
      resultData.payDate = 'ИТОГО';

      if (this.$store.state.report.filters.groupTypes.length) {
        resultData.cntPays = '';
      }

      return resultData;
    }
  }
